import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ICartSummaryResponseV2) {
    (function(ICartSummary) {
        ICartSummary.build = function(partial) {
            return _object_spread({
                brand_line_items: [],
                general_line_items: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ICartSummaryResponseV2.ICartSummary || (ICartSummaryResponseV2.ICartSummary = {}));
    (function(IBrandCartSummary) {
        IBrandCartSummary.build = function(partial) {
            return _object_spread({
                brand_promos: [],
                order_summary_line_items: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ICartSummaryResponseV2.IBrandCartSummary || (ICartSummaryResponseV2.IBrandCartSummary = {}));
    ICartSummaryResponseV2.build = function(partial) {
        return _object_spread({
            brand_cart_summaries: {}
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ICartSummaryResponseV2 || (ICartSummaryResponseV2 = {}));
export var ICartSummaryResponseV2;
